import * as R from 'ramda'
import React, { useEffect , useState, useContext, Fragment, useCallback } from 'react'
import { Link } from 'gatsby'
import Cookies from 'js-cookie'

import { GlobalContext } from '../../context/globalContext'
import { serverUrl, serverPrefixUrl } from '../../config'
import G from '../../util/globalFunction'
import AllMenus from '../menus'
import TF from '../../util/tremFunction'
import tremApi from '../../util/tremApi'
import LoginUserDeptCheckPopup from '../shared/loginUserDeptCheck'

//메뉴 목록을 가져옴. 만일 권한에 따라 오픈 메뉴가 틀리면 조정해줄 것
const getMenus = () => AllMenus.public

const Menu = ({ title, menus }) => (
    <li>
        <a href="javascript:void(0);" onFocus={() => {document.getElementById("header").style.height = "410px"}}>{G.t(title)}</a>
        <ul className="depth2">
            {menus.map(({ title, route }, index) => (
                <li key={index} onFocus={() => {document.getElementById("header").style.height = "410px"}}>
                    <a onClick={()=>{TF.setAccessPageHistory(route);G.gotoPage(route);}}>{G.t(title)}</a>
                    {/*<Link to={route} onClick={ () => TF.setAccessPageHistory(route)}>{G.t(title)}</Link>*/}
                </li>
            ))}
        </ul>
    </li>
)

const MobileMenus = ({ title, menus, flag, registeOpenMenu, setfold }) => (
    <li>
        <a className="depth1_m" onClick={() => registeOpenMenu(title)}>
            {G.t(title)}
        </a>
        <ul className="depth2 block">
            {flag &&
                menus.map(({ title, route:route1, menus: children }, index) => (
                    <li key={index}>
                        <Link to={route1} onClick={ () => TF.setAccessPageHistory(route1)}>{G.t(title)}</Link>
                        {children && (
                            <ul className="depth3 block">
                                {children.map(({ title, route:route2, foreword, gotoProps }, index) => (
                                    <li key={index}>
                                        {foreword ? (
                                            <a href={route2} alt={title} onClick={ () => TF.setAccessPageHistory(route2)}>
                                                {G.t(title)}
                                            </a>
                                        ) : (
                                            //props 보내주고 싶을 땐 state에
                                            <Link 
                                                to={route2=='/'? route1 : route2} 
                                                onClick={()=>{setfold(true); TF.setAccessPageHistory(route2);}}
                                                state={gotoProps}> {G.t(title)}  
                                            </Link> 
                                        )}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
        </ul>
    </li>
)

const Header = props => {
    const menus = getMenus()
    const [unfold, setUnfold] = useState(true)
    const [openMenus, setOpenMenus] = useState([])
    const [timer, settimer] = useState([])
    const msize = G.getMediaSize()
    const globalContext = useContext(GlobalContext)
    
    const { loginInfo, setSSOinfo, logout, refresh, setSessionStartDt } = globalContext
    let { loggined, NAME, ENG_NAME, JOIN_TYPE } = loginInfo()


    let tid = null //setInterval 함수
    let originRemainSeconds = 10801 //초기타이머값 (단위:초)

    const sendHello = useCallback((e) =>{
        e.preventDefault()
        sessionStorage.setItem('timeData',originRemainSeconds) //초기값으로 
    },[])

    // 시간 포맷 세팅
    const setTimerFormat = (seconds) => {
        let nHour = 0
        let nMin = 0
        let nSec = 0
        if(seconds > 0) {
            nMin = parseInt(seconds / 60)
            nSec = seconds % 60
            if(nMin > 60) {
                nHour = parseInt(nMin / 60)
                nMin = nMin % 60
            }
        }
        if(nSec < 10) {
            nSec = "0" + nSec
        }
        if(nMin < 10) {
            nMin = "0"+nMin
        }
    
        return "" + nHour + ":" + nMin + ":" + nSec
    }

    // 세션 storage 제거
    const removeSessionStorage = useCallback(() => {
        sessionStorage.removeItem('timeData')
    },[])
    
    // 타이머 세팅
    const setTimer = () => {
        tid = setInterval(async() => {
            let remainSeconds = sessionStorage.getItem('timeData')*1
            if(remainSeconds){
                remainSeconds--
                const timer = setTimerFormat(remainSeconds)
                settimer(timer)
                sessionStorage.setItem('timeData',remainSeconds)
    
                if(remainSeconds == 300) { //세션종료 5분 전부터 로그아웃 알림
                    alert(G.t('trem.lang.home.0957')) /* 5분 후 자동 로그아웃됩니다. */
                }
                    
            }
            if(!remainSeconds || remainSeconds < 0){ // 로그아웃
                clearInterval(tid)
                removeSessionStorage()
                logout()
            }
        }, 1000)
    }
    
    // useEffect(() => {
    //     //로그인 상태일때 실행
    //     if(loggined){
    //         sessionStorage.setItem('timeData',originRemainSeconds) 
    //         setTimer()
    //     }else{ //아닐시 setInterval clear
    //         clearInterval(tid)
    //     }
    //     return () => { //페이지 이동 및 렌더링 시 setInterval clear, storage삭제
    //         clearInterval(tid)
    //         removeSessionStorage()
    //     }
    // }, [])
    useEffect(() => {
        setSSOinfo()
    }, [loggined])

    const handleLoginClick = e => {
        e.preventDefault()

        if(loggined){
            if(window.confirm(G.t('trem.lang.home.0904'))){
                logout()
                G.gotoLoginPage()
            }
        }else{
                G.gotoLoginPage()
        }    /* 로그아웃 하시겠습니까? */
    }

    const toggleMobileMenu = e => {
        e.preventDefault()
        setUnfold(!unfold)
    }

    const registeOpenMenu = title =>
        R.pipe(
            R.ifElse(
                () => openMenus.includes(title),
                () => {
                    const tmp = []
                    for (const t of openMenus) {
                        if (t !== title) {
                            tmp.push(t)
                        }
                    }
                    return tmp
                },
                () => [...openMenus, title]
            ),
            setOpenMenus
        )()
        
    const currentLang = Cookies.get('__floor_lang__') || 'ko'
    const toggleLang = e => {
        e.preventDefault()
        Cookies.set('__floor_lang__', currentLang === 'ko' ? 'en' : 'ko')
        refresh()
    }

    const maskClassName = !unfold && ['sm', 'md'].includes(msize) ? 'mask show' : 'mask'
    const mobileMenuClassName = !unfold && ['sm', 'md'].includes(msize) ? 'all_menu_wrap' : 'hidden'

    // const fnDuplicateCheckByLogout = async () => {
        
    //     const properties = await TF.getProperity()
    //     const sessionDuplicCheck = properties.sshDuplicateCheck

    //     if( loggined && sessionDuplicCheck === "Y"){

    //         await tremApi("/session/info/hm/duplicate/check/logout").then(rslt => {
    //             let isExist = rslt.isExist;
    //             let message = rslt.message;

    //             if(isExist){
    //                 alert(message, null, function () {
    //                     logout();
    //                 });
    //             }
    //         })
    //     }
    // }

    // fnDuplicateCheckByLogout()

    return (
        <Fragment>
            <div id="header" className={currentLang === 'ko' ? "" : "header_en"}>
                <div className="inner">
                    <h1 className={currentLang === 'ko' ? "" : "logo_en"}>
                        <Link to={`/`} onClick={ () => TF.setAccessPageHistory(`/`)}>
                            {G.t('trem.lang.home.0938')}
                            {/* TREE 연구인프라 통합관리시스템 */}
                        </Link>
                    </h1>
                    <a className="all_menu_btn" onClick={toggleMobileMenu}>
                        전체메뉴
                    </a>
                    <div className="hidden md:block">
                        <div className="header_box">
                            <a className="login" href="javascript:void(0);" onClick={handleLoginClick}>
                                {loggined ? G.t('trem.lang.home.0004') : G.t('trem.lang.home.0001')}
                                {/* loggined ? 로그아웃 : 로그인 */}
                            </a>
                            {loggined && (
                                <Fragment>
                                    
                                        <Link to={`/home/collabi/myPage/reservation/list`} onClick={ () => TF.setAccessPageHistory('/home/collabi/myPage/reservation/list')}>
                                            {G.t('trem.lang.home.0005')} 
                                            {/* 마이페이지  */}
                                        </Link>
                                    
                                    { (JOIN_TYPE === "M" || JOIN_TYPE === "P") && (
                                    
                                        <Link to={`${serverUrl}${serverPrefixUrl}/home`} onClick={ () => TF.setAccessPageHistory(`${serverUrl}${serverPrefixUrl}/home`)}>
                                            {G.t('trem.lang.home.0006')}
                                            {/* 운영 */}
                                        </Link>
                                    
                                    )}
                                </Fragment>
                            )}

                            {!loggined && (
                                <Fragment>
                                    <a href="https://www.seoulbiohub.kr/front/user/userRegistStep1Page.do">
                                        {G.t('trem.lang.home.0002')}
                                        {/* 회원가입 */}
                                    </a>
                                    <a href="https://www.seoulbiohub.kr/front/user/findIdPass.do?gbn=idsearch">
                                        {G.t('trem.lang.home.0003')}
                                        {/* 아이디찾기 */}
                                    </a>
                                </Fragment>
                            )}
                            <a className="language" href="javascript:void(0);" onClick={toggleLang}>
                                {currentLang !== 'ko' ? 'KOR' : 'ENG'}
                            </a>

                            {loggined && (
                                <div className="top_user">
                                    <a
                                        href="javascript:void(0);" onClick={() => G.gotoPage('/home/collabi/myPage/user/info')}
                                        className="top_name"
                                    >
                                        <span>{currentLang === "ko" ? NAME : ENG_NAME}</span>
                                    </a>
                                    <span className="timeCounter"></span>
                                    <a href="javascript:void(0);" onClick={()=>setSessionStartDt()} className="top_time">
                                        {G.t('trem.lang.home.0007')} 
                                        {/* 문구 주석처리 해주세요 => 연장하기 */}
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    <ul className="top_menu">
                        { menus.map((menu, index) => (
                            <Menu key={index} { ...menu } />
                        )) }
                    </ul>

                    {/* <ul style={{height: '0px', width: '0px', background: 'none'}}>
                        <a href="javascript:void(0);" onFocus={() => {document.getElementById("header").style.height = "110px"}}></a>
                    </ul> */}
                </div>
            </div>
            <div className={mobileMenuClassName}>
                <div className={currentLang === 'ko' ? "all_top" : "all_top all_top_en"}>
                    <ul>
                        <li>
                            <a className="login" href="javascript:void(0);" onClick={handleLoginClick}>
                                {loggined ? G.t('trem.lang.home.0004') : G.t('trem.lang.home.0001')}
                                {/* loggined ? '로그아웃' : '로그인' */}
                            </a>
                        </li>
                        {loggined ? (
                            <Fragment>
                                <li>
                                    <Link to="/home/collabi/myPage/reservation/list" onClick={ () => TF.setAccessPageHistory('/home/collabi/myPage/reservation/list')}>
                                        {G.t('trem.lang.home.0005')}
                                        {/* 마이페이지 */}
                                    </Link>
                                </li>
                                { (JOIN_TYPE === "M" || JOIN_TYPE === "P") && (
                                     <li>
                                        <Link to={`${serverUrl}${serverPrefixUrl}/home`} onClick={ () => TF.setAccessPageHistory(`${serverUrl}${serverPrefixUrl}/home`)}>
                                            {G.t('trem.lang.home.0006')}
                                            {/* 운영 */}
                                        </Link>
                                    </li>
                                    )}
                            </Fragment>
                        ) : (
                            <Fragment>
                                <li>
                                    <a href="https://www.seoulbiohub.kr/front/user/userRegistStep1Page.do">
                                        {G.t('trem.lang.home.0002')}
                                        {/* 회원가입 */}
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.seoulbiohub.kr/front/user/findIdPass.do?gbn=idsearch">
                                        {G.t('trem.lang.home.0003')}
                                        {/* 아이디찾기 */}
                                    </a>
                                </li>
                            </Fragment>
                        )}
                    </ul>
                    <a className="language" href="javascript:void(0);" onClick={toggleLang}>
                        {currentLang !== 'ko' ? 'KOR' : 'ENG'}
                    </a>
                    <a className="close" href="javascript:void(0);" onClick={toggleMobileMenu}>
                        {G.t('trem.lang.home.0146')}
                        {/* 닫기 */}
                    </a>
                </div>
                {loggined && (
                    <div className="all_user">
                        <a href="javascript:void(0);" onClick={() => G.gotoPage('/home/collabi/myPage/user/info')} className="top_name">
                            [ <span>{currentLang === "ko" ? NAME : ENG_NAME}</span>{G.t('trem.lang.home.0681')} ]
                        </a>
                        <span className="timeCounter"></span>
                        <a href="javascript:void(0);" onClick={()=>setSessionStartDt()} className="top_time">
                            {G.t('trem.lang.home.0007')}
                            {/* 연장하기 */}
                        </a>
                    </div>
                )}
                <div className="all_con">
                    <ul className="depth1">
                        {menus.map((menu, index) => (
                            <MobileMenus
                                key={index}
                                {...menu}
                                setfold = {setUnfold}
                                registeOpenMenu={registeOpenMenu}
                                flag={openMenus.includes(menu.title)}
                            />
                        ))}
                    </ul>
                </div>
            </div>
            <div className={maskClassName}></div>

            {/* <input type="text" style={{position:"absolute", top:"0", left:"0", width:"1px", height:"1px", margin:"0", padding:"0", border:"0"}}  id="pubAaccessAdderssURL" name="pubAaccessAdderssURL" value="" /> */}
            <LoginUserDeptCheckPopup/>
           
        </Fragment>
    )
}

export default Header
